// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextArea_textarea__XSLHj","label":"TextArea_label__WtAjT","description":"TextArea_description__FBBDC"};